// Cleaning Planned Hours (in minutes) by Equipment Category and Cleaning Type
// These are constant values for Type-A and Type-C cleaning durations

export const CLEANING_PLANNED_HOURS = Object.freeze({
  'Granulation': {
    'Type-A': 2 * 60, // 2 hours in minutes
    'Type-C': 18 * 60, // 18 hours in minutes
  },
  'FBP': {
    'Type-A': 2 * 60,
    'Type-C': 18 * 60,
  },
  'Blending': {
    'Type-A': 2 * 60,
    'Type-C': 7 * 60,
  },
  'Compression': {
    'Type-A': 2 * 60,
    'Type-C': 18 * 60,
  },
  'Coating': {
    'Type-A': 3 * 60,
    'Type-C': 18 * 60,
  },
  'Capsulation': {
    'Type-A': 4 * 60,
    'Type-C': 18 * 60,
  },
  'Imprinting': {
    'Type-A': 2 * 60, // Default same as other areas
    'Type-C': 18 * 60,
  },
  'Packing': {
    'Type-A': 2 * 60,
    'Type-C': 18 * 60,
  },
  'Other': {
    'Type-A': 2 * 60,
    'Type-C': 18 * 60,
  },
});

/**
 * Get the planned duration for cleaning activities in HH:MM format
 * @param {string} equipmentCategory - Equipment category (Granulation, FBP, etc.)
 * @param {string} cleaningType - Cleaning type (Type-A, Type-C, etc.)
 * @returns {string} Duration in HH:MM format, or null if not a Type-A/Type-C cleaning
 */
export const getCleaningPlannedDuration = (equipmentCategory, cleaningType) => {
  // Only return constant values for Type-A and Type-C
  if (!cleaningType || (!cleaningType.includes('Type-A') && !cleaningType.includes('Type-C'))) {
    return null;
  }

  const category = CLEANING_PLANNED_HOURS[equipmentCategory] || CLEANING_PLANNED_HOURS['Other'];
  const normalizedType = cleaningType.includes('Type-A') ? 'Type-A' : 'Type-C';
  const minutes = category[normalizedType];

  if (minutes === undefined || minutes === null) {
    return null;
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}:${mins.toString().padStart(2, '0')}`;
};

/**
 * Get the planned duration in minutes for cycle variance calculation
 * @param {string} equipmentCategory - Equipment category
 * @param {string} cleaningType - Cleaning type
 * @returns {number|null} Duration in minutes, or null if not a Type-A/Type-C cleaning
 */
export const getCleaningPlannedMinutes = (equipmentCategory, cleaningType) => {
  if (!cleaningType || (!cleaningType.includes('Type-A') && !cleaningType.includes('Type-C'))) {
    return null;
  }

  const category = CLEANING_PLANNED_HOURS[equipmentCategory] || CLEANING_PLANNED_HOURS['Other'];
  const normalizedType = cleaningType.includes('Type-A') ? 'Type-A' : 'Type-C';
  return category[normalizedType] || null;
};

export default CLEANING_PLANNED_HOURS;
